import { useMemo } from "react";
import { useSelector } from "react-redux";
import { createSelector } from "reselect";
import { EngineerHandle } from "resource-planner-model";
import { AppState } from "../redux/AppTypes";

export const createEngineerSelector = () =>
  createSelector(
    (state: AppState) => state.engineers.items,
    (_: AppState, id: string) => id,
    (items, id) => {
      const engineer = items[id];
      return engineer ? new EngineerHandle(engineer) : undefined;
    }
  );

export function useEngineer(id: string): EngineerHandle | undefined {
  const selector = useMemo(createEngineerSelector, []);
  return useSelector((state: AppState) => selector(state, id));
}
